import PropTypes from 'prop-types';
import * as React from 'react';

import { Col, Row } from 'components/bootstrap';
import { DocumentTitle, PageHeader, Spinner } from 'components/common';
import withParams from 'routing/withParams';
import DocsHelper from 'util/DocsHelper';

import ReportConfiguration from './ReportConfiguration';

import ReportSubNav from '../common/ReportSubNav';
import ReportValidations from '../common/ReportValidations';
import useReportAndLogo from '../hooks/useReportAndLogo';

type Props = {
  params: {
    reportId: string,
  },
};

const ReportConfigurationPage = ({ params: { reportId } }: Props) => {
  const { report, reportLogo } = useReportAndLogo(reportId);

  if (!report) {
    return <Spinner text="Loading report data, please wait..." />;
  }

  return (
    <DocumentTitle title={`Report ${report.title} configuration`}>
      <PageHeader title={<span>Report <em>{report.title}</em> configuration</span>}
                  actions={<ReportSubNav reportId={report.id} />}
                  documentationLink={{
                    title: 'Reporting documentation',
                    path: DocsHelper.PAGES.REPORTING,
                  }}>
        <span>
          Configure the report layout and delivery schedule, adapting it to your needs.
        </span>
      </PageHeader>

      <ReportValidations />

      <Row className="content">
        <Col md={12}>
          <ReportConfiguration report={report} reportLogo={reportLogo} />
        </Col>
      </Row>
    </DocumentTitle>
  );
};

ReportConfigurationPage.propTypes = {
  params: PropTypes.exact({
    reportId: PropTypes.string.isRequired,
  }).isRequired,
};

export default withParams(ReportConfigurationPage);
